export default {
    init() {
    },
    finalize() {
        function toggleTerms() {
            if(!$('.terms-popup').hasClass('active')) {
                $('.terms-popup').addClass('active');
                $('#backdrop').addClass('active');
                
                if($(window).width() < 768) {
                    $('body').addClass('no-scroll');
                }

                return;
            }

            $('.terms-popup').removeClass('active');
            $('#backdrop').removeClass('active');
            $('body').removeClass('no-scroll');
        }

        $('a[href="#open-terms"]').click(toggleTerms);
        $('.terms-control').click(toggleTerms);
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-competitions.js